import React, { useEffect, useState } from 'react';
import { Col, Row } from 'antd';
import useApi from '../../hooks/useApi';
import { isEmpty } from '../../generalFunctions';
import NoticeBoard from './NoticeBoard';
import ExternalLinkButton from './ExternalLinkButton';

const ExternalLinks = ({ apiUrl }) => {
    const [response, request] = useApi("/website/home/external-links");
    const [externalLinks, setExternalLinks] = useState([]);

    useEffect(() => {
        request();
    }, []);//eslint-disable-line

    useEffect(() => {
        if (!isEmpty(response.data) && !response.error && !response.isLoading) {
            setExternalLinks(response.data);
        }

    }, [response]);

    return (
        <Row>
            {externalLinks.map(element =>
                <Col span={24}>
                    <ExternalLinkButton key={element.id} label={element.text} link={element.link} />
                </Col>
            )}
        </Row>
    );
}

export default ExternalLinks;